import { navigationSetInStoreAction } from 'common/actions/navigation';

export const navigationReducer = (state = [], action) => {
  switch (action.type) {
    case navigationSetInStoreAction().type:
      return action.payload.navigation;

    default:
      return state;
  }
};
